import { studySpaceClient } from './StudySpaceClient';
import { StudySpaceEntityType } from '@faro/study-space-service-model';

export class StudySpaceService {
    get = studySpaceClient.get;
    list = studySpaceClient.list;
}

export const studySpaceEntityType: StudySpaceEntityType = 'study-space';
